import { mixed, object } from 'yup'
import { t } from 'ttag'

import { FILE_FIELD } from './model'

export const getSchema = () =>
  object().shape({
    [FILE_FIELD]: mixed().test(
      'is',
      t`This field cannot be empty.`,
      value => value.length > 0,
    ),
  })
